export default __webpack_public_path__ + "static/media/gameplay-icon-11.84309a4c.gif";